import {
  auditListQuerySchema,
  auditListResponseSchema,
  auditLookupsSchema,
  type AuditListQuery,
} from '@gb-ticket/shared-types';
import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';
import { toSearchParams } from '@/lib/format';

export const auditLookupsQueryKey = ['audit', 'lookups'] as const;
export const auditQueryKey = (query: AuditListQuery) => ['audit', 'list', query] as const;

export function useAuditLookups(enabled = true) {
  return useQuery({
    queryKey: auditLookupsQueryKey,
    queryFn: () => apiFetch('/audit/lookups', auditLookupsSchema),
    enabled,
  });
}

export function useAuditLog(query: AuditListQuery, enabled = true) {
  const parsed = auditListQuerySchema.parse(query);
  return useQuery({
    queryKey: auditQueryKey(parsed),
    queryFn: () =>
      apiFetch(
        `/audit${toSearchParams({
          page: parsed.page,
          pageSize: parsed.pageSize,
          sortOrder: parsed.sortOrder,
          q: parsed.q,
          actorId: parsed.actorId,
          action: parsed.action,
          entityType: parsed.entityType,
          entityId: parsed.entityId,
          from: parsed.from,
          to: parsed.to,
        })}`,
        auditListResponseSchema,
      ),
    enabled,
  });
}
